import {useState, useEffect} from 'react';
import { ReactComponent as ProfilePicture } from '@Assets/blankProfile.svg';
import { MdPerson as PersonIcon } from 'react-icons/md';
import './SearchUserRow.scss';

export default function SearchUserRow(props) {

    const [isDisabled, setIsDisabled] = useState(false);
    const className = 'searchUserRow';

    useEffect(()=> {
        handleUserDisable();
    },[props]);

    const dataURLtoFile = (dataurl) => {
        var arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], { type: mime });
    }

    const handleUserDisable = () => {
        if((Object.keys(props?.activeUsers).length !== 0) && (props?.activeUsers?.some(item => item.id === props?.user?.id))) {
            setIsDisabled(true);
        } else {
            setIsDisabled(false);
        }
    }

    return (
        <div className={className}>
            <div className={`${className}__left`} onClick={props?.handleUserClick}>
                <div className={`${className}__avatar`}>
                    {props?.user.photo !== undefined && props?.user.photo !== null && props?.user.photo !== '' ? (
                        <img src={URL.createObjectURL(dataURLtoFile(props?.user.photo))} alt='profile'/>
                    ) : (
                        <PersonIcon />
                    )}
                </div>
                <div className={`${className}__info`}>
                    <div className={`${className}__name`}>{props?.user?.fullName}</div>
                    <div className={`${className}__username`}>@{props?.user?.userName}</div>
                </div>
            </div>
            <div className={`${className}__right`}>
                <button
                    className={`${className}__add`}
                    onClick={props?.handleAddUser}
                    disabled={isDisabled}>
                    {isDisabled ? 'Already Added' : 'Add User'}
                </button>
            </div>
        </div>
    );
}
